import {
    getAxios,
} from './axios'

import {addAuthTokenData} from './member';
import {responseResolveInterceptor} from './interceptors';

export function getVirtualGifts({nick}) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/gift_catalog/',
        method: 'get',
        params: {...addAuthTokenData({r: nick})}
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/virtualGifts.js